var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6803 25.7212L44.5295 24.0324C47.0355 20.0028 45.5419 14.8319 41.2018 12.5056C36.8632 10.1802 31.2927 11.5648 28.7868 15.5944L25.636 13.9056C29.1453 8.26274 36.9448 6.32354 43.021 9.58036C49.0988 12.838 51.1896 20.0783 47.6803 25.7212Z",
    fill: "#C9C9D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6803 25.7212L44.0447 31.5685L22 19.7528L25.636 13.9056L28.7868 15.5944L25.1492 21.4407L40.8955 29.8806L44.5316 24.0338L47.6803 25.7212Z",
    fill: "#C9C9D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8182 45.8726H30.1818V39.1208H33.8182V45.8726Z",
    fill: "#C9C9D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 28.9932V56.0002H52V28.9932H12ZM15.6364 52.6243H48.3636V32.369H15.6364V52.6243Z",
    fill: "#C9C9D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock-open.21aea05020533273674a502bb6da33e4.svg";
export { ForwardRef as ReactComponent };